<template>
  <div id="board overview-board">
    <div class="notification is-danger" v-if="errorMessage">{{ errorMessage }}</div>

    <template v-if="cards">
      <div class="level board-header">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">{{ board ? board.title : ''}}</h1>
          </div>
          <div class="level-item">
            <last-updated/>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <ui-time-picker/>
          </div>
        </div>
      </div>

      <div>
        <grid-layout
          :layout="cards"
          :col-num="12"
          :row-height="12"
          :is-draggable="false"
          :is-resizable="false"
          :vertical-compact="true"
          :margin="[20, 0]"
          :use-css-transforms="true"
        >
          <grid-item
            v-for="item in cards"
            :key="item.card_id"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            :class="item.card_id"
          >
            <component :is="getCard(item.card_id)" :id="item.id"/>
          </grid-item>
        </grid-layout>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueGridLayout from "vue-grid-layout";
import store from "store";

// components
import LastUpdated from "elements/LastUpdated";

// cards
import UsageStatsCard from "./usage/UsageStatsCard";
import GeographyOverviewCard from "./geography/GeographyOverviewCard";
import TimeVisualizationCard from "./time/TimeVisualizationCard";
import TimeVisualizationInsightsCard from "./time/TimeVisualizationInsightsCard";
import TransportDistributionCard from "./transport/TransportDistributionCard";
import TransportModeOverviewCard from "./transport/TransportModeOverviewCard";
import LocationTypeOverviewCard from "./location/LocationTypeOverviewCard";
import LocationTypeOverviewInsightsCard from "./location/LocationTypeOverviewInsightsCard";
import NotFoundCard from "elements/states/NotFoundCard";

const { GridLayout, GridItem } = VueGridLayout;

// card classes
const classes = {
  "usage-stats-card": UsageStatsCard,
  "geography-overview-card": GeographyOverviewCard,
  "time-visualization-card": TimeVisualizationCard,
  "time-visualization-insights-card": TimeVisualizationInsightsCard,
  "transport-distribution-card": TransportDistributionCard,
  "transport-mode-overview-card": TransportModeOverviewCard,
  "location-type-overview-card": LocationTypeOverviewCard,
  "location-type-overview-insights-card": LocationTypeOverviewInsightsCard,
  "not-found-card": NotFoundCard
};

export default {
  components: {
    LastUpdated,
    GridLayout,
    GridItem,
    ...classes
  },

  data() {
    return {
      errorMessage: ""
    };
  },

  computed: {
    ...mapGetters("application", ["board", "cards"])
  },

  beforeRouteEnter(to, from, next) {
    store
      .dispatch("application/loadBoard", to.params.boardId)
      .then(next)
      .catch(err => {
        // FIXME handle this properly, as in, probably in the store
        throw new Error(err);
        // this.errorMessage = this.$t('errors.no_cards');
      });
  },

  methods: {
    getCard(id) {
      return classes[id] ? id : "not-found-card";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.level-left {
  align-items: baseline;
}

.board-header {
  margin-bottom: 2.5rem;

  .title {
    margin-bottom: 0;
  }
}

.last-updated {
  display: flex;
  color: $black;
  font-size: 0.875rem;
  line-height: 1.43;
  font-style: oblique;
  opacity: 0.64;
  margin-left: 2rem;

  i {
    font-size: 0.875rem;
    line-height: 1.43;
    margin-right: 0.375rem;
  }
}

.vue-grid-layout {
  margin-left: -20px;
  margin-right: -20px;
}

.vue-grid-item {
  padding-bottom: 40px;
  transition: none;

  &:hover {
    z-index: 10;
  }

  .card {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}
</style>

<style lang="scss">
.vue-grid-item {
  .card-content {
    flex: 1;
  }
}
</style>
